import DataItemListResourcePagingResultModel from '../../generated/types/model/resource/DataItemListResourcePagingResultModel';

export default class DataItemListResourcePagingResultViewModel extends DataItemListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
